<template>
  <b-card-code>
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col :style="userData == 'admin' ? '' : 'display: none'" md="3">
            <b-form-group>
              <label>Sales By</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                :rules="userData == 'admin' ? 'required' : ''"
                name="Sales By"
              >
                <v-select
                  placeholder="None"
                  v-model="selecttype"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  @input="selecttypee($event)"
                  label="name"
                  :options="['Employee', 'CompanyAssociatePartner', 'Franchise', 'Direct']"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col :style="selecttype != 'Direct' ? '' : 'display: none'" md="3">
            <b-form-group>
              <label>Select {{ selecttype }}</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                :rules="
                  userData == 'employee' || selecttype == 'Employee' ? 'required' : ''
                "
                name="Employee"
              >
                <v-select
                  placeholder="None"
                  v-model="selectedteam"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  :options="teamOption"
                  @input="userInfo($event)"
                >
                  <template #option="{ name, profile_image, username, surname }">
                    <b-avatar :src="getprofileImage(profile_image)" />
                    <span class="font-weight-bolder"> {{ name }} {{ surname }}</span
                    ><span>({{ username }})</span>
                  </template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Booking Date</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Booking Date"
              >
                <flat-pickr
                  v-model="bookingdate"
                  class="form-control"
                  :config="{
                    dateFormat: 'd/m/Y',
                    defaultDate: new Date(),
                  }"
                  style="background-color: transparent"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>Booking Type </label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Booking Type"
              >
                <v-select
                  placeholder="None"
                  @input="handelClickBooking($event)"
                  v-model="bookingtype"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  :options="['Full Amount', 'Part Payment']"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="12" :style="userDetails ? '' : 'display:none'">
            <b-row>
              <b-col md="3">
                <label>Email</label>
                <b-form-input disabled v-model="userDetails.email"
              /></b-col>
              <b-col md="3">
                <label>Phone No</label>
                <b-form-input disabled v-model="userDetails.mobile"
              /></b-col>
              <b-col md="3">
                <label>Username</label>
                <b-form-input disabled v-model="userDetails.username"
              /></b-col>
              <b-col md="3">
                <label>Photo :</label>
                <b-media-aside>
                  <b-link>
                    <b-img
                      rounded
                      :src="
                        userDetails.profile_image
                          ? userDetails.profile_image
                          : 'https://aircraft.wpenginepowered.com/wp-content/uploads/2016/09/no-profile-img.jpg'
                      "
                      height="80"
                    />
                  </b-link> </b-media-aside
              ></b-col>
              <!-- <b-col md="3">
                <label>Pancard No</label>
                <b-form-input disabled v-model="userDetails.panno"
              /></b-col> -->
            </b-row>
          </b-col>
          <b-col md="12">
            <b-card-code title="Application Form" no-body>
              <b-col></b-col>
            </b-card-code>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>In SIR?</label>
              <v-select
                placeholder="None"
                v-model="sir"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                @input="handleSIR"
                :options="['Yes', 'No']"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>Village Name (New Survay No.)</label>
              <label style="color: red !important">*</label>
              <div class="d-flex">
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="Village Name"
                  style="flex-grow: 1;"
                >
                  <v-select
                    placeholder="None"
                    v-model="village"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="villagename"
                    @input="getVillageById($event)"
                    :options="villageOption"
                  >
                    <template #option="{ villagename, surveynonew }">
                      <span class="font-weight-bolder"> {{ villagename }} </span
                      ><span>({{ surveynonew }})</span>
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <b-button
                  variant="primary"
                  class="ml-1"
                  @click="$bvModal.show('land-purchase-data-modal')"
                >
                  <feather-icon icon="SearchIcon" />
                </b-button>
              </div>
            </b-form-group>
          </b-col>
          <b-col md="3" :style="sir == 'Yes' ? '' : 'display:none'">
            <b-form-group>
              <label>Zone</label>
              <!-- <v-select
                placeholder="None"
                v-model="zone"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :options="zoneOptions"
              /> -->
              <b-form-input placeholder="Zone" v-model="zone.name" />
            </b-form-group>
          </b-col>
          <b-col md="3" :style="sir == 'Yes' ? '' : 'display:none'">
            <b-form-group>
              <label>Selelct T.P.</label>
              <!-- <v-select
                placeholder="None"
                v-model="tpno"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                @input="handleSubTP"
                :options="[1, 2, 3, 4, 5, 6]"
              /> -->
              <b-form-input placeholder="Tp No." v-model="tpno" disabled />
            </b-form-group>
          </b-col>
          <b-col md="3" :style="sir == 'Yes' ? '' : 'display:none'">
            <b-form-group>
              <label>Selelct Sub T.P.</label>
              <!-- <v-select
                placeholder="None"
                v-model="subtpno"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :options="subtpOptions"
                @input="handleSubTp"
              /> -->
              <b-form-input placeholder="Sub Tp No." v-model="subtpno" disabled />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Survey No. New</label>
              <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Survey No. New"
              >
                <!-- <v-select
                  v-model="newsurveyno"
                  placeholder="None"
                  label="surveynonew"
                  :options="newsurveynoOption"
                  @input="surveyNo($event)"
                /> -->
                <b-form-input
                  placeholder="New Survay No."
                  v-model="newsurveyno"
                  disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Old Survay No.</label>

              <b-form-input placeholder="Old Survay No." v-model="oldsurveyno" disabled />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>F.P. No.</label>
              <b-form-input
                placeholder="Enter F.P. No."
                v-model="fpno"
                disabled
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>F.P. Area /Land size (In Sq. Yard)</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Land Size"
              >
                <b-form-input
                  v-model="fparea"
                  placeholder="Enter F.P. Area"
                  type="number"
                  disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- <b-col md="3">
            <b-form-group>
              <label>Land Map</label>
              <b-form-file v-model="landmap" placeholder="Select Document" drop-placeholder="Drop file here..."
                @input="handleMultiFileChange($event, 'landsales', 'landmap')" />
            </b-form-group>
            <attachment :data="landmap" />
          </b-col> -->
          <b-col md="12">
            <b-card-code title="Rate Details" no-body>
              <b-col></b-col>
            </b-card-code>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>CP Rate</label>
              <b-form-input disabled v-model="cprate" placeholder="Enter Rate" />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>Bulk Land Rate</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Bulk Land Rate"
              >
                <b-form-input
                  disabled
                  v-model="landrate"
                  placeholder="Enter Rate"
                  type="number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group>
              <label>With NA?</label>

              <label style="color: red !important">*</label>

              <validation-provider #default="{ errors }" rules="required" name="With NA">
                <v-select
                  disabled
                  placeholder="None"
                  v-model="withna"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="['Yes', 'No']"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="3" :style="withna == 'No' ? '' : 'display:none'">
            <b-form-group>
              <label>NA Charges Per Bigha</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                :rules="withna == 'No' ? 'required' : ''"
                name="Charges Per Bigha"
              >
                <b-form-input
                  v-model="nacharges"
                  disabled
                  placeholder="Enter NA Charges"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- <b-col md="3">
            <b-form-group>
              <label>T.P. Road</label>
              <b-form-input v-model="tproad" placeholder="Enter T.P. Area" />
            </b-form-group>
          </b-col> -->

          <!-- <b-col md="3">
            <b-form-group>
              <label>Bulk Land Area(Sq. Yard)</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Bulk LandArea(Sq. Yard)"
              >
                <b-form-input
                  disabled
                  v-model="landareasqyard"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Bulk Land Area(Sq. Yard)"
                  @input="handleLandArea('yd')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Bulk Land Area(Sq.Feet)</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Bulk Land Area(Sq.Feet)"
              >
                <b-form-input
                  disabled
                  v-model="landareasqfeet"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Bulk Land Area(Sq.Feet)"
                  @input="handleLandArea('ft')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col> -->

          <!-- <b-col md="3">
            <b-form-group>
              <label>Owner's Rate</label>
              <b-form-input v-model="ownerrate" placeholder="Enter T.P. Area" />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>CP Final Rate</label>
              <b-form-input
                v-model="cpfinalrate"
                placeholder="Enter T.P. Area"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>Customer Rate</label>
              <b-form-input
                v-model="customerrate"
                placeholder="Enter T.P. Area"
              />
            </b-form-group>
          </b-col> -->
          <b-col md="3">
            <b-form-group>
              <label>Remarks</label>
              <b-form-textarea
                id="remarks"
                placeholder="Enter remarks"
                v-model="remarks"
                rows="1"
              />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Land Jantri Rate/ Govt. Guideline Rs.</label>
              <b-form-input
                v-model="jantrirate"
                disabled
                placeholder="Enter Land Jantri Rate"
              />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Payment Type</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Payment Type"
              >
                <v-select
                  placeholder="None"
                  v-model="paymenttype"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="['Down Payment', 'Token']"
                  @input="handleToken"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="3" :style="paymenttype == 'Token' ? '' : 'display:none'">
            <b-form-group>
              <label>Payment Token</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                :rules="paymenttype == 'Token' ? 'required' : ''"
                name="Payment Token"
              >
                <b-form-input
                  v-model="paymenttoken"
                  placeholder="Enter Payment Token"
                  @input="handleToken"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Payment Terms Days</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Payment Terms Days"
              >
                <b-form-input
                  v-model="paymenttermday"
                  type="number"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Payment Terms Days"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group>
              <label>Payment Through</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Payment Through"
              >
                <v-select
                  placeholder="None"
                  v-model="paymentthrough"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  :options="paymentThroughOption"
                  @input="handleSelectPayment"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-card-code title="Payment Details" no-body>
              <b-col></b-col>
            </b-card-code>
          </b-col>
          <b-col md="3" v-if="noChequeField">
            <b-form-group>
              <label>Bank Name</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Bank Name"
              >
                <b-form-input
                  v-model="bankname"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Bank Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3" v-if="noChequeField">
            <b-form-group>
              <label>Reference Number</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Reference Number"
              >
                <b-form-input
                  v-model="refno"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Reference Number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3" v-if="noChequeField">
            <b-form-group>
              <label>Upload Receipt</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Upload Receipt "
              >
                <b-form-file
                  v-model="bankreceipt"
                  placeholder="Select Document"
                  drop-placeholder="Drop file here..."
                  @input="handleMultiFileChange($event, 'sales', 'receipt')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <attachment :data="bankreceipt" />
          </b-col>
          <b-col md="3" v-if="noChequeField">
            <b-form-group>
              <label>Date</label>
              <label style="color: red !important">*</label>

              <validation-provider #default="{ errors }" rules="required" name="Date">
                <flat-pickr
                  v-model="bankdate"
                  class="form-control"
                  :config="{
                    dateFormat: 'd/m/Y',
                    defaultDate: new Date(),
                    maxDate: new Date(),
                  }"
                  style="background-color: transparent"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3" v-if="noChequeField">
            <b-form-group>
              <label>Remarks</label>
              <label style="color: red !important">*</label>

              <validation-provider #default="{ errors }" rules="required" name="Remarks">
                <b-form-textarea
                  id="Remarks"
                  v-model="bankremarks"
                  :state="errors.length > 0 ? false : null"
                  rows="1"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3" v-if="chequeField">
            <b-form-group>
              <label>Cheque No</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Cheque No"
              >
                <b-form-input
                  v-model="chequeno"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Cheque No"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3" v-if="chequeField">
            <b-form-group>
              <label>Bank Name</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Bank Name"
              >
                <b-form-input
                  v-model="bankname"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Bank Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3" v-if="chequeField">
            <b-form-group>
              <label>Cheque Date:</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Cheque Date"
              >
                <flat-pickr
                  v-model="chequedate"
                  class="form-control"
                  :config="{
                    dateFormat: 'd/m/Y',
                    defaultDate: new Date(),
                    maxDate: new Date(),
                  }"
                  style="background-color: transparent"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3" v-if="chequeField">
            <b-form-group>
              <label>Status</label>
              <label style="color: red !important">*</label>

              <validation-provider #default="{ errors }" rules="required" name="Status">
                <v-select
                  placeholder="None"
                  v-model="status"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  :options="['Pending', 'Bounce', 'Clear']"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12"> </b-col>

          <b-col md="4">
            <b-form-group>
              <label>Total Payment</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Total Payment"
              >
                <b-form-input
                  v-model="totalpayment"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Total Payment"
                  disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>First Payment</label>
              <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                :rules="firstPaymentRules"
                name="First Payment"
              >
                <b-form-input
                  v-model="firstpayment"
                  type="number"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter First Payment"
                  @input="handleRemaining"
                />
                <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                <small class="text-danger">{{
                  errors[0] == "The First Payment field must be 10000 or more"
                    ? "The First Payment field must be accept more than 5 figure Amount"
                    : errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Remaining Payment</label>
              <label style="color: red !important">*</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Remaining Payment"
              >
                <b-form-input
                  v-model="remainingpayment"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Remaining Payment"
                  disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="12" :style="bookingtype == 'Part Payment' ? '' : 'display:none'">
            <!-- <b-col md="12"> -->
            <b-card-code title="INSTALLMENTS" no-body>
              <b-col></b-col>
            </b-card-code>
          </b-col>

          <b-col md="12" :style="bookingtype == 'Part Payment' ? '' : 'display:none'">
            <!-- <b-col md="12"> -->
            <table class="table table-bordered">
              <thead class="text">
                <tr>
                  <th></th>
                  <th>Installment date</th>
                  <th>Installment Amount</th>
                  <th>Remarks</th>
                  <th :style="bookingtype == 'Part Payment' ? '' : 'display:none'">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(installment, index) in installments" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <flat-pickr
                      v-model="installment.installment_date"
                      class="form-control"
                      :config="{
                        dateFormat: 'd/m/Y',
                        defaultDate: new Date(),
                      }"
                      style="background-color: transparent"
                    />
                  </td>
                  <td>
                    <b-form-input
                      v-model="installment.installment_amount"
                      placeholder="Enter Installment Amount"
                    />
                  </td>
                  <td>
                    <b-form-input
                      v-model="installment.remarks"
                      placeholder="Enter Installment Remarks"
                    />
                  </td>
                  <td :style="bookingtype == 'Part Payment' ? '' : 'display:none'">
                    <b-button
                      variant="outline-danger"
                      class="mt-0"
                      @click="deleteRow(index)"
                    >
                      <feather-icon icon="TrashIcon" class="" />
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
            <b-button
              :style="bookingtype == 'Part Payment' ? '' : 'display:none'"
              variant="primary"
              class="mt-1"
              @click="addRow"
            >
              Add more
            </b-button>
          </b-col>
          <!-- <b-col md="6">
            <b-form-group>
              <label>Ledger</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Number"
              >
                <v-select placeholder="None"
                  v-model="selectedLedger"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  :options="ledgerOption"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col> -->
          <b-col md="12">
            <b-card-code title="Customer Details" no-body>
              <b-col></b-col>
            </b-card-code>
          </b-col>
          <b-col md="12">
            <b-form-group>
              <label>Customer Name</label>
              <label style="color: red !important">*</label>
              <div class="d-flex">
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="Customer Name"
                  style="flex-grow: 1"
                >
                  <v-select
                    v-model="selectedCustomers"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="customerOption"
                    label="name"
                    multiple
                    placeholder="None"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <b-button
                  variant="primary"
                  size="sm"
                  @click="handlePopUp"
                  class="ml-1 align-self-start"
                >
                  +
                </b-button>
              </div>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-table
              responsive
              :items="selectedCustomers"
              :fields="customerTableFields"
              class="mt-2"
              show-empty
            >
              <template #cell(percentage)="data">
                <b-form-input
                  v-model="data.item.percentage"
                  type="number"
                  placeholder="%"
                  @input="validatePercentage"
                />
              </template>
              <template #cell(actions)="data">
                <b-button
                  variant="outline-primary"
                  @click="editCustomer(data.item)"
                >
                  <feather-icon icon="EditIcon" />
                </b-button>
                <b-button
                  variant="outline-danger"
                  @click="removeCustomer(data.index)"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
              </template>
            </b-table>
          </b-col>

          <b-col md="4" :style="status == 'Yes' ? '' : 'display: none'">
            <b-form-group>
              <label>Remarks</label>
              <b-form-input v-model="remarks" placeholder="Enter remarks" />
            </b-form-group>
          </b-col>
          
          <b-col md="4">
            <b-form-group>
              <label>Nominee</label>
              <label style="color: red !important">*</label>

              <validation-provider #default="{ errors }" rules="required" name="Nominee">
                <b-form-input
                  v-model="nominee"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Nominee"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Nominee Relationship</label>
              <label style="color: red !important">*</label>

              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Nominee Relationship"
              >
                <b-form-input
                  v-model="nomineerelation"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Nominee Relationship"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Nominee Phone</label>
              <label style="color: red !important">*</label>

              <validation-provider #default="{ errors }" name="Nominee Phone">
                <b-form-input
                  v-model="nomineephone"
                  maxlength="10"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Nominee Phone"
                  @keydown="onlyDigits"
                  @paste="handlePaste"
                  @input="validateNomineePhone"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Nominee DOB</label>
              <flat-pickr
                v-model="nomineedob"
                class="form-control"
                :config="{
                  dateFormat: 'd/m/Y',
                  defaultDate: new Date(),
                  maxDate: new Date(),
                }"
                style="background-color: transparent"
              />
            </b-form-group>
            </b-col>
            
          <b-col md="4" :style="status == 'Yes' ? '' : 'display: none'">
            <b-form-group>
              <label>Remarks</label>
              <b-form-input v-model="remarks" placeholder="Enter remarks" />
            </b-form-group>
          </b-col>           
          <!-- <b-col md="12">
            <b-form-group>
              <label style="font-size: 16px">Send:&nbsp;</label>
              <b-form-checkbox v-model="sendemail" inline>
                Email
              </b-form-checkbox>
              <b-form-checkbox v-model="sendsms" inline> SMS </b-form-checkbox>
              <b-form-checkbox v-model="sendwhatsapp" inline>
                Whatsapp
              </b-form-checkbox>

            </b-form-group>
          </b-col> -->

          <!-- submit button -->
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              :disabled="flag || submitDisable"
              @click.prevent="submitForm"
              class="mr-1"
            >
              Submit
            </b-button>
            <b-button variant="primary" @click="onClickBack">Back </b-button>
            <b-button
              v-if="$route.params.id && userData == 'admin' && status == 'Yes'"
              :disabled="this.active == 0"
              class="ml-1"
              variant="danger"
              @click="handleApprove"
              >Cancel
            </b-button>
          </b-col>
        </b-row>
        <b-modal
          id="modal-form"
          v-model="popUpVisible"
          size="lg"
          cancel-variant="outline-secondary"
          ok-title="Submit"
          cancel-title="Close"
          :title="isEditingCustomer ? 'Edit Customer' : 'Add Customer'"
          hide-footer
          @hidden="resetEditingCustomer"
        >
          <add-customer
            :fromSales="true"
            :selectedUser="selectedteam"
            :closePopUp="closePopUp"
            :getCustomer="getCustomer"
            :edit="isEditingCustomer"
            :customerData="editingCustomer"
            @customer-updated="onCustomerUpdated"
          />
        </b-modal>
        <land-purchase-data-popup @land-purchase-selected="handleLandPurchaseSelected" />
      </b-form>
    </validation-observer>

    <!-- <template #code>
      {{ codeType }}
    </template> -->
  </b-card-code>
</template>

<script>
import BCardCode from "@core/components/b-card-code";
import LandPurchaseDataPopup from "./LandPurchaseDataPopup.vue";
import AddCustomer from "../customer/AddCustomer.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import PinchScrollZoom from "@coddicat/vue-pinch-scroll-zoom";
import {
  BImg,
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BImgLazy,
  BFormFile,
  BFormCheckbox,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BAvatar,
  BTable
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
  min_value,
} from "@validations";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import axios from "@/components/axios";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import Attachment from "../../../components/Attechment.vue";
import image from "../../../assets/images/pages/no-image.png";

export default {
  components: {
    LandPurchaseDataPopup,
    BMedia,
    BTable,
    BMediaAside,
    BMediaBody,
    BLink,
    BImg,
    AddCustomer,
    flatPickr,
    BFormCheckbox,
    PinchScrollZoom,
    Datepicker,
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormFile,
    BButton,
    vSelect,
    BFormDatepicker,
    BFormTextarea,
    BImgLazy,
    Attachment,
    BAvatar,
  },
  data() {
    return {
      selecttype: "",
      selectedteam: "",
      bookingdate: moment(new Date()).format("DD/MM/yyyy"),
      bookingtype: "",
      zone: "",
      tpno: "",
      subtpno: "",
      village: "",
      newsurveyno: "",
      oldsurveyno: "",
      fpno: "",
      fparea: "",
      landmap: "",
      cprate: "",
      landrate: "",
      withna: "",
      nacharges: "",
      landareasqyard: "",
      landareasqfeet: "",
      remarks: "",
      jantrirate: "",
      paymenttype: "",
      paymenttoken: "",
      paymenttermday: "",
      paymentthrough: "",
      bankreceipt: "",
      bankdate: moment(new Date()).format("DD/MM/yyyy"),
      bankremarks: "",
      refno: "",
      chequeno: "",
      bankname: "",
      chequedate: moment(new Date()).format("DD/MM/yyyy"),
      status: "",
      installments: [],
      totalpayment: "",
      firstpayment: "",
      remainingpayment: "",
      title: "",
      customer: [],
      address: "",
      pincode: "",
      city: "",
      area: "",
      state: "",
      country: "India",
      dateofbirth: moment(new Date()).format("DD/MM/yyyy"),
      mobileNo: "",
      email: "",
      adharno: "",
      panno: "",
      nominee: "",
      nomineerelation: "",
      nomineephone: "",
      nomineedob: moment(new Date()).format("DD/MM/yyyy"),
      chequeField: false,
      selectedCustomers: [],
      customerTableFields: [
        { key: "name", label: "Name" },
        { key: "mobile", label: "Mobile" },
        { key: "email", label: "Email" },
        { key: "aadharcardno", label: "Aadhar" },
        { key: "panno", label: "PAN" },
        { key: "percentage", label: "Percentage" },
        { key: "actions", label: "Actions" },
      ],
      active: 1,
      visible: false,
      accessToken: localStorage.getItem("accessToken"),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      teamOption: [],
      paymentThroughOption: [
        "By Cheque",
        "By RTGS",
        "By NEFT",
        "By ECS",
        "Debit/Credit Card",
        "Net Banking",
        "By UPI",
        "Other",
      ],
      firstPaymentRules: "required|min_value:10000",
      ctitleOption: [
        { name: "Shri." },
        { name: "Smt." },
        { name: "Ms." },
        { name: "Mrs." },
        { name: "Mr." },
      ],
      areaOption: [],
      cityOption: [],
      editingCustomer:{},
      adharnoValidate: true,
      pannoValidate: true,
      ifEdit: false,
      noChequeField: false,
      userData: "",
      userName: "",
      flag: false,
      submitDisable: false,
      dashboard: false,
      fromState: "",
      stateOptions: [],
      StateData: [],
      customerOption: [],
      popUpVisible: false,
      userDetails: "",
      parent: "",
      zoneOptions: [],
      newsurveynoOption: [],
      allVillageOption: [],
      villageOption: [],
      isEditingCustomer:false,
      subtpOptions: [],
      subTP: {
        1: ["1A-1", "1A-2", "1A-3", "1A-4", "1A-5", "1B"],
        2: ["2A", "2B-1", "2B-2", "2B-3", "2B-4", "2B-5", "2B-6"],
        3: ["3A", "3B", "3C", "3D"],
        4: ["4A", "4B-1", "4B-2"],
        5: ["5A", "5B", "5C-1", "5C-2"],
        6: ["6A", "6B"],
      },
      sir: "",
      singleVillages: [],
      loginData: {},
      imagePath: process.env.VUE_APP_IMAGE_PATH,
    };
  },
  destroyed() {
    localStorage.removeItem("landData");
  },
  async mounted() {
    const rights = JSON.parse(localStorage.getItem("UserRights"));
    const role = JSON.parse(localStorage.getItem("userData")).role;
    if (role !== "admin") {
      rights.map((item) => {
        if (item.modulename == "Land Sales") {
          if (this.$route.params.id) {
            if (item.edit !== 1) {
              this.$router.push("/crm/landsales");
            }
          } else if (item.add !== 1) {
            this.$router.push("/crm/landsales");
          }
        }
      });
    }
    this.getState();
    await this.getVillage();
    // await this.getZone();

    this.loginData = JSON.parse(localStorage.getItem("userData"));
    this.userData = this.loginData.role;
    this.userName = this.loginData.name;
    this.userId = this.loginData.id;
    this.init();

    this.ifEdit = !!this.$route.params.id;
    this.ifEdit && this.getEditValue();
  },
  watch: {
    selectedCustomers(newVal) {
      newVal.forEach(customer => {
        if (customer.percentage === undefined) {
          this.$set(customer, 'percentage', null);
        }
      });
      this.validatePercentage();
    }
  },
  methods: {
    onlyDigits(event) {
      // Allow special keys: backspace, delete, tab, escape, enter
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
      
      // Allow navigation keys
      const navigationKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      
      // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
      if ((event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) {
        return;
      }
      
      // Allow special keys and navigation keys
      if (allowedKeys.includes(event.key) || navigationKeys.includes(event.key)) {
        return;
      }
      
      // Only allow digits (0-9)
      if (!/^[0-9]$/.test(event.key)) {
        event.preventDefault();
        return false;
      }
    },
    handlePaste(event) {
      event.preventDefault();
      const paste = (event.clipboardData || window.clipboardData).getData('text');
      const numbers = paste.replace(/\D/g, '');
      this.nomineephone = numbers;
    },
    validateNomineePhone() {
      // Remove any non-digit characters (handles paste operations and other edge cases)
      this.nomineephone = this.nomineephone.replace(/\D/g, '');
    },
    validatePercentage() {
      const totalPercentage = this.selectedCustomers.reduce((total, customer) => {
        return total + (parseFloat(customer.percentage) || 0);
      }, 0);

      if (totalPercentage > 100) {
        this.$swal({
          title: "Warning",
          text: "Total percentage cannot exceed 100.",
          icon: "warning",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },
    handleLandPurchaseSelected(data) {
      console.log(data,"data-poo");
      // Map new camelCase API fields to old field names expected by getVillageById
      const fpAreaValue = data.fpArea || data.fparea || '';
      
      // Convert naStatus (R+/A+) to withna (Yes/No)
      // R+ means "Yes" (Residential/Ready), A+ means "No" (Agricultural/Available)
      let withnaValue = data.withna;
      if (!withnaValue && data.naStatus) {
        const naStatusStr = String(data.naStatus).toUpperCase().trim();
        if (naStatusStr === 'R+' || naStatusStr === 'YES' || naStatusStr === '1' || naStatusStr === 'TRUE') {
          withnaValue = 'Yes';
        } else if (naStatusStr === 'A+' || naStatusStr === 'NO' || naStatusStr === '0' || naStatusStr === 'FALSE') {
          withnaValue = 'No';
        }
      }
      
      const mappedData = {
        ...data,
        // Map village name
        villagename: data.village || data.villagename,
        // Map survey numbers
        surveynonew: data.newSurveyNo || data.surveynonew,
        surveynoold: data.oldNo || data.surveynoold,
        // Map FP fields
        fpno: data.fpNo || data.fpno,
        fparea: fpAreaValue,
        // Set totalarea as fallback (getVillageById uses this if isfp != "Yes")
        totalarea: fpAreaValue || data.totalarea,
        // Set isfp to "Yes" so it uses fparea instead of totalarea
        isfp: data.isfp || "Yes",
        // Map rate fields
        marketrate: data.rate || data.marketrate,
        cprate: data.rate || data.cprate,
        // Map withna field (convert from naStatus if needed)
        withna: withnaValue || data.withna || '',
        // Map NA charges field
        nacharges: data.naCharges || data.nacharges || data.na_charges || '',
        // Map other fields that might be needed
        tpno: data.tpNo || data.tpno,
        subtpno: data.subTp || data.subtpno,
        zone: data.zone || data.zone,
        // Keep id
        id: data.id
      };
      
      // Set village object for the dropdown
      this.village = { 
        villagename: mappedData.villagename, 
        id: mappedData.id 
      };
      
      // Call getVillageById with mapped data
      this.getVillageById(mappedData);
    },
    getprofileImage(image) {
      if (image !== undefined && image !== null && image !== "") {
        let test = image.includes(this.imagePath) ? image : this.imagePath + image;
        return test;
      }
      return image;
    },
    handleSIR(e) {
      let villagesSir = [];
      let villages = [];

      this.allVillageOption.map((item) => {
        if (item.tpno) {
          villagesSir.push(item);
        } else {
          villages.push(item);
        }
      });
      if (e == "Yes") {
        this.villageOption = villagesSir;
      } else if (e == "No") {
        this.villageOption = villages;
      }
    },
    handleSubTp() {
      this.villageOption = [];
      this.allVillageOption.map((item) => {
        if (item.subtpno == this.subtpno && item.is_purchase == 1 && item.is_sales == 0) {
          this.villageOption.push(item);
        }
      });
      const resArr = [];
      this.villageOption.filter(function (item) {
        const i = resArr.findIndex((x) => x.villagename == item.villagename);
        if (i <= -1) {
          resArr.push(item);
        }
        return null;
      });
      this.villageOption = resArr;
    },
    // async getZone() {
    //   const requestOptions = {
    //     method: "GET",
    //     headers: {
    //       "Content-type": "application/json",
    //       Authorization: `Bearer ${this.accessToken}`,
    //     },
    //     url: `${this.baseApi}/zone`,
    //   };
    //   await axios(requestOptions).then((response) => {
    //     this.zoneOptions = response.data.data.data;
    //   });
    // },
    // handleSubTP() {
    //   this.subtpno = "";
    //   this.subtpOptions = this.subTP[this.tpno];
    // },
    getVillageById(e) {
      if (e) {
        // this.newsurveynoOption = [];
        this.newsurveyno = e.surveynonew;
        this.oldsurveyno = e.surveynoold;
        this.tpno = e.tpno;
        this.subtpno = e.subtpno;
        this.fpno = e.fpno;
        this.fparea = e.isfp == "Yes" ? e.fparea : e.totalarea;
        this.cprate = e.cprate;
        this.withna = e.withna;
        this.nacharges = e.nacharges;
        this.landrate = e.marketrate;
        this.totalpayment = this.landrate * this.fparea;
        this.zone = e.zone ? e.zone : "";
        this.jantrirate = e.Jantrirate;
      }
      this.handleToken();
    },
    //
    async getVillage(id) {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/landmaster?pagesize=10000&pagenum=1`,
      };
      await axios(requestOptions)
        .then((response) => {
          this.allVillageOption = response.data.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    handlevillageAtEdit(id) {
      this.allVillageOption.map((item) => {
        if (item.id == id) {
          this.village = item;
          this.villageOption.push(item);
          this.getVillageById(this.village);
          this.newsurveyno = item;
          this.newsurveynoOption.push(item);
        }
      });
      this.villageOption.map((item, index) => {
        if (item.name == this.village.villagename) {
          this.villageOption[index] = this.village;
        }
      });
    },
    handleRemaining() {
      this.remainingpayment = this.totalpayment - this.firstpayment;
      this.$forceUpdate();
    },
    handleToken() {
      let minValue;
      if (this.paymenttype == "Down Payment") {
        minValue = (this.totalpayment * 25) / 100;
        this.firstPaymentRules = `required|min_value:${minValue}`;
      } else if (this.paymenttype == "Token") {
        minValue = this.paymenttoken;
        this.firstPaymentRules = `required|min_value:${minValue}`;
      }
      this.handleRemaining();
    },
    // handleNA() {
    //   this.totalpayment =
    //     this.landrate * this.fparea + this.fparea * this.nacharges;
    // },
    handleLandArea(type) {
      if (type == "yd") {
        this.landareasqfeet = parseFloat((this.landareasqyard / 0.333).toFixed(3));
      } else {
        this.landareasqyard = parseFloat((this.landareasqfeet * 0.333).toFixed(3));
      }
    },
    async userInfo(e) {
      let id = null;
      if (e && e.id) {
        id = e.id;
      } else {
        id = e;
      }
      const requestoption = {
        method: "GET",
        url: `${this.baseApi}/getusersbyid/${id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      };
      await axios(requestoption).then((response) => {
        this.userDetails = response.data.data[0];
        if (this.userDetails.role !== "admin") {
          // this.userDetails.parent;
        }
        this.getCustomer(this.userDetails.id);
      });
    },
    // async getParent(id) {
    //   const requestoption = {
    //     method: "GET",
    //     url: `${this.baseApi}/getusersbyid/${id}`,
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${this.accessToken}`,
    //     },
    //   };
    //   await axios(requestoption).then((response) => {
    //     this.parent = response.data.data[0].name;
    //   });
    // },
    closePopUp() {
      this.popUpVisible = false;
      this.resetEditingCustomer();
    },
    handlePopUp() {
      if (this.selectedteam || this.selecttype == "Direct") {
        this.popUpVisible = true;
      } else {
        this.$swal({
          title: "Warning",
          timer: 5000,
          text: "Plese Select User !",
          icon: "warning",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },

    editCustomer(customer) {
      this.editingCustomer = { ...customer };
      this.isEditingCustomer = true;
      this.popUpVisible = true;
    },
    onCustomerUpdated(updatedCustomer) {
      const index = this.selectedCustomers.findIndex(c => c.id === updatedCustomer.id);
      if (index !== -1) {
        this.selectedCustomers.splice(index, 1, updatedCustomer);
      }
      this.closePopUp();
    },
    resetEditingCustomer() {
      this.editingCustomer = null;
      this.isEditingCustomer = false;
    },

    removeCustomer(index) {
      this.selectedCustomers.splice(index, 1);
      this.validatePercentage();
    },

    async getCustomer(id) {
      const data = {
        assignto: id,
      };
      const requestoption = {
        method: "POST",
        url: `${this.baseApi}/getcustomerassignby`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        data: JSON.stringify(data),
      };
      await axios(requestoption).then((response) => {
        this.customerOption = response.data.data;
      });
    },
    async getCustomerDetails(e) {
      if (e) {
        const requestoption = {
          method: "GET",
          url: `${this.baseApi}/getusersbyid/${e}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
        };
        await axios(requestoption).then((response) => {
          const details = response.data.data[0];
          this.customer = details;
          this.handleCustomer(details);
        });
      }
    },
    handleCustomer(details) {
      this.email = details.email;
      this.mobileNo = details.mobile;
      this.dateofbirth =
        details.birthdate == "00/00/0000" || details.birthdate == null
          ? null
          : details.birthdate;
      this.pincode = details.curpincode;
      this.area = details.curarea;
      this.city = details.curcity;
      this.state = details.curstate;
      this.adharno = details.aadharcardno;
      this.panno = details.panno;
      this.address = details.curaddressline1 + " " + details.curaddressline2;
      this.nominee = details.nomineename;
      this.nomineerelation = details.nomineerelation;
      this.nomineephone = details.nomineephone;
      this.nomineedob = details.nomineedob;
      this.title = details.title;
    },
    async handleArea() {
      const reportauthority = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getAreaByCity`,
        data: {
          City: this.city,
        },
      };
      await axios(reportauthority)
        .then((response) => {
          this.areaOption = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    async getState() {
      const reportauthority = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getState`,
      };
      await axios(reportauthority)
        .then((response) => {
          this.stateOptions = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    selecttypee(e) {
      this.selecttype = e;
      this.selectedteam = null;
      if (this.selecttype == "Direct") {
        this.selectedteam = {
          id: this.userId,
        };
        this.userInfo(this.userId);
        this.getCustomer(this.userId);
      } else if (this.selecttype == "CompanyAssociatePartner") {
        this.getCompanyAssociatePartner();
      } else if (this.selecttype == "Franchise") {
        this.getFranchise();
      } else if (this.selecttype == "Employee") {
        this.getTeam();
      }
    },
    async handleMultiFileChange(e, type, name) {
      this.flag = true;
      const formData = new FormData();
      formData.append("image", e);
      formData.append("type", type);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.accessToken}`,
        },
        data: formData,
        url: `${this.baseApi}/attachment`,
      };
      await axios(requestOptions)
        .then((response) => {
          if (name == "receipt") {
            this.bankreceipt = process.env.VUE_APP_IMAGE_PATH + response.data.attachment;
          } else {
            this.landmap = process.env.VUE_APP_IMAGE_PATH + response.data.attachment;
          }
          this.flag = false;
        })
        .catch((error) => console.log(error, "error"));
    },
    handelClickBooking(e) {
      this.bookingtype = e;
      if (e == "Part Payment") {
        this.handlePartPayment();
      }
      this.$forceUpdate();
    },
    handlePartPayment() {
      this.installments = [
        {
          installment_date: moment(new Date()).format("DD/MM/YYYY"),
          installment_amount: 0,
          remarks: "",
          type: "Part Payment",
        },
      ];
    },
    async getEditValue() {
      // console.log(this.$route.params.id, "id====");
      await axios({
        method: "GET",
        url: `${this.baseApi}/getlandsalesById/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((json) => {
          this.getEditItems(json.data.data[0]);
        })
        .catch((error) => console.log(error, "error"));
    },
    getEditItems(item) {
      this.selecttype = item.selecttype;
      this.selectedteam = item.selectedteam ? item.selectedteam : {};
      this.userDetails = item.selectedteam ? item.selectedteam : {};

      this.bookingdate = item.bookingdate;
      this.bookingdate =
        item.bookingdate == "00/00/0000" || item.bookingdate == null
          ? null
          : item.bookingdate;
      this.bookingtype = item.bookingtype;

      this.zone = item.zone || {};
      this.tpno = item.tpno;
      this.subtpno = item.subtpno;
      this.village = item.village || {};
      this.newsurveyno = item.newsurveyno;
      this.oldsurveyno = item.oldsurveyno;
      this.fpno = item.fpno;
      this.fparea = item.fparea;
      // this.landmap = item.landmap;

      this.cprate = item.cprate;
      this.landrate = item.landrate;
      this.withna = item.withna;
      this.nacharges = item.nacharges;
      this.landareasqyard = item.landareasqyard;
      this.landareasqfeet = item.landareasqfeet;
      this.remarks = item.remarks;
      this.jantrirate = item.jantrirate;
      this.paymenttype = item.paymenttype;
      this.paymenttoken = item.paymenttoken;
      this.paymenttermday = item.paymenttermday;
      this.paymentthrough = item.paymentthrough;

      this.totalpayment = item.totalpayment;
      this.firstpayment = item.firstpayment;
      this.remainingpayment = item.remainingpayment;

      this.bankname = item.bankname;
      this.refno = item.refno;
      this.bankreceipt = item.bankreceipt;
      this.bankdate = item.bankdate;
      this.bankremarks = item.bankremarks;
      this.chequedate = item.chequedate;
      this.chequeno = item.chequeno;
      this.status = item.status;
      this.customer = item.customer ? item.customer : {};
      this.installments = item.installments;
      this.sir = item.subtpno ? "Yes" : "No";
      
      let customers = [];
      if (item.customers && item.customers.length > 0) {
        try {
          customers = item.customers;
        } catch (e) {
          console.error("Error parsing customerjson", e);
          customers = [];
        }
      }
      this.selectedCustomers = Array.isArray(customers) ? customers.filter(c => c) : [];
      if (this.selectedteam && this.selectedteam.id) {
        this.getCustomer(this.selectedteam.id);
      }
      this.address = this.address;
      
      // Handle customer data - check if customer is array or object
      let customerData = this.customer;
      if (Array.isArray(this.customer) && this.customer.length > 0) {
        customerData = this.customer[0];
      }
      
      // Set nominee fields FIRST from item (landsales record) - these should take priority
      // Only fall back to customer data if item doesn't have nominee fields
      this.nominee = item.nominee || item.nomineename || '';
      this.nomineerelation = item.nomineerelation || item.nomineerelationship || '';
      this.nomineephone = item.nomineephone || item.nomineePhone || '';
      this.nomineedob = item.nomineedob || '';
      
      // Call handleCustomer to set customer-related fields (but don't overwrite nominee if already set from item)
      if (customerData && Object.keys(customerData).length > 0) {
        // Temporarily store nominee values before handleCustomer
        const savedNominee = this.nominee;
        const savedNomineeRelation = this.nomineerelation;
        const savedNomineePhone = this.nomineephone;
        const savedNomineeDob = this.nomineedob;
        
        this.handleCustomer(customerData);
        
        // Restore nominee fields from item if they were set, otherwise use customer data
        this.nominee = savedNominee || this.nominee || '';
        this.nomineerelation = savedNomineeRelation || this.nomineerelation || '';
        this.nomineephone = savedNomineePhone || this.nomineephone || '';
        this.nomineedob = savedNomineeDob || this.nomineedob || '';
      }
      this.handleCity();
      this.handleArea();
      this.handleSelectPayment(item.paymentthrough);
      this.handleSIR(this.sir);
    },
    handleSelectPayment(e) {
      const name = e;
      if (name == "By Cheque") {
        this.chequeField = true;
      } else {
        this.chequeField = false;
      }
      if (name !== "Other" && name !== "By Cheque" && name !== "By UPI") {
        this.noChequeField = true;
      } else {
        this.noChequeField = false;
      }
    },

    handlePincode() {
      if (this.fromState == true) {
        this.pincode = this.area.Pincode;
      }
    },
    async handleCity() {
      this.areaOption = [];
      this.cityOption = [];
      this.fromState = true;
      const reportauthority = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getCityByState`,
        data: {
          State: this.state,
        },
      };
      await axios(reportauthority)
        .then((response) => {
          this.cityOption = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    async handleArea() {
      const reportauthority = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getAreaByCity`,
        data: {
          City: this.city,
        },
      };
      await axios(reportauthority)
        .then((response) => {
          this.areaOption = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    clickArea(e) {
      if (this.fromState == true) {
        this.handleArea();
      }
      //   this.areaOption = []
      // this.StateData.map((item) => {
      //   if (item.City == e) {
      //     this.areaOption.push(item.PostOfficeName)
      //   }
      // })
    },
    async clickPincode() {
      this.area = "";
      this.city = "";
      this.state = "";
      this.cityOption = [];
      this.areaOption = [];
      const regex = new RegExp(/^[0-9]{6}$/);
      if (regex.test(this.pincode)) {
        this.fromState = false;
        const reportauthority = {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
          url: `${this.baseApi}/pincode`,
          data: {
            Pincode: `${this.pincode}`,
          },
        };
        await axios(reportauthority)
          .then((response) => {
            this.cityOption = [];
            this.StateData = response.data.data;
            this.areaOption = response.data.data;
            this.state = response.data.data[0];
            const resArr = [];
            response.data.data.filter(function (item) {
              const i = resArr.findIndex((x) => x.City == item.City);
              if (i <= -1) {
                resArr.push(item);
              }
              return null;
            });
            this.cityOption = resArr;
          })
          .catch((error) => console.log(error, "error"));
      }
    },
    validatePanClick(e) {
      const regex = new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
      this.panno = this.panno.toUpperCase();
      if (regex.test(this.panno) == true) {
        this.pannoValidate = true;
      } else {
        this.pannoValidate = false;
      }
    },
    validateAadharClick(e) {
      const regex = new RegExp(/^[2-9]{1}[0-9]{3}\s{1}[0-9]{4}\s{1}[0-9]{4}$/);
      this.adharno.length == 4 ? (this.adharno = this.adharno.concat(" ")) : this.adharno;
      this.adharno.length == 9 ? (this.adharno = this.adharno.concat(" ")) : this.adharno;
      if (regex.test(this.adharno) == true) {
        this.adharnoValidate = true;
      } else {
        this.adharnoValidate = false;
      }
    },

    onClickBack() {
      this.$router.push("/crm/bulklandsales");
    },
    submitForm(e) {
      if (this.selectedCustomers.length > 0) {
        const totalPercentage = this.selectedCustomers.reduce((total, customer) => {
          return total + (parseFloat(customer.percentage) || 0);
        }, 0);

        if (totalPercentage !== 100) {
          this.$swal({
            title: "Warning",
            text: "Total partnership percentage must be exactly 100.",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          return;
        }
      }
      console.log(this.selectedCustomers,"asasasas");
      let part = true;
      let data;
      let json = this.selectedCustomers.map((item) => {return {id: item.id,name: item.name,mobile: item.mobile,email: item.email,aadharcardno: item.aadharcardno,panno: item.panno, percentage: item.percentage}})
      const data1 = {
        selecttype: this.selecttype,
        selectedteam: this.selectedteam.id,
        bookingdate: this.bookingdate,
        bookingtype: this.bookingtype,
        zone: this.zone.id,
        tpno: this.tpno,
        subtpno: this.subtpno,
        village: this.village.id,
        newsurveyno: this.newsurveyno,
        oldsurveyno: this.oldsurveyno,
        fpno: this.fpno,
        fparea: this.fparea,
        // landmap: this.landmap,
        cprate: this.cprate,
        landrate: this.landrate,
        withna: this.withna,
        nacharges: this.nacharges,
        landareasqyard: this.landareasqyard,
        landareasqfeet: this.landareasqfeet,
        remarks: this.remarks,
        jantrirate: this.jantrirate,
        paymenttype: this.paymenttype,
        paymenttoken: this.paymenttoken,
        paymenttermday: this.paymenttermday,
        paymentthrough: this.paymentthrough,
        totalpayment: this.totalpayment,
        firstpayment: this.firstpayment,
        remainingpayment: this.remainingpayment,
        bankname: this.bankname,
        refno: this.refno,
        bankreceipt: this.bankreceipt,
        bankdate: this.bankdate,
        bankremarks: this.bankremarks,
        chequedate: this.chequedate,
        chequeno: this.chequeno,
        status: this.status,
        customerjson: json,
        nominee: this.nominee,
        nomineename: this.nominee,
        nomineerelation: this.nomineerelation,
        nomineerelationship: this.nomineerelation,
        nomineephone: this.nomineephone,
        nomineePhone: this.nomineephone,
        nomineedob: this.nomineedob,
      };
      if (this.bookingtype == "Part Payment") {
        const installment = {
          installments: this.installments,
        };
        data = {
          ...data1,
          ...installment,
        };
      } else {
        data = data1;
      }
      this.$refs.simpleRules.validate().then(async (success) => {
        if (
          success == false ||
          this.pannoValidate == false ||
          this.adharnoValidate == false
        ) {
          this.$swal({
            title: "Warning",
            timer: 5000,
            text: "Plese Fill the All Field",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        }
        if (this.bookingtype == "Part Payment") {
          let total = parseFloat(this.firstpayment) || 0;
          this.installments.map((item) => {
            total += parseFloat(item.installment_amount) || 0;
          });
          // Compare with tolerance for floating point precision
          const totalPayment = parseFloat(this.totalpayment) || 0;
          const difference = Math.abs(total - totalPayment);
          // Allow small difference due to floating point precision (0.01)
          if (difference > 0.01) {
            part = false;
            this.$swal({
              title: "Warning",
              timer: 5000,
              text: "Installmant amount should be equal to total payment",
              icon: "warning",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
          }
        }
        if (
          success &&
          this.pannoValidate == true &&
          this.adharnoValidate == true &&
          part == true
        ) {
          this.submitDisable = true;
          const accessToken = localStorage.getItem("accessToken");
          const baseApi = process.env.VUE_APP_APIENDPOINT;
          await axios({
            method: `${this.ifEdit ? "put" : "post"}`,
            url: this.ifEdit
              ? `${baseApi}/landsales/${this.$route.params.id}`
              : `${baseApi}/landsales`,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            data: JSON.stringify(data),
          })
            .then((json) => {
              this.submitDisable = true;

              this.$swal({
                title: "Submited",
                text: json.data.message
                  ? `${json.data.message}`
                  : json.data.success
                  ? `${json.data.success}`
                  : json.data.success
                  ? "Update SuccessFully"
                  : "Submitted SuccessFully",
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
              this.$router.push("/crm/bulklandsales");
            })
            .catch((error) => {
              this.submitDisable = false;
              let message = "";

              const code = error.toString().includes("409");
              if (code) {
                for (let key in error.response.data.message.original) {
                  message += error.response.data.message.original[key][0] + " ";
                }
              }
              this.$swal({
                title: "Error!",
                text: message ? `${message}` : error,
                icon: "error",
                timer: 5000,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    getLandData() {
      let data = JSON.parse(localStorage.getItem("landData"));

      this.village = data.village;
      this.sir = data.sir;
      this.userDetails = this.loginData;
      this.selectedteam = this.loginData;
      if (this.selectedteam.role == "companyassociatepartner") {
        this.selecttype = "Company Associate Partner";
      } else if (this.selectedteam.role == "franchise") {
        this.selecttype = "Franchise";
      } else if (
        this.selectedteam.role == "employee" &&
        this.selectedteam.type != "Account Assistant"
      ) {
        this.selecttype = "Employee";
      } else if (
        this.selectedteam.role == "admin" ||
        this.selectedteam.type == "Account Assistant"
      ) {
        this.selecttype = "Direct";
      }
      this.getVillageById(this.village);
    },
    async init() {
      if (localStorage.getItem("landData")) {
        this.getLandData();
      }
      if (this.userData == "companyassociatepartner") {
        this.downlineCP();

        this.selecttype = "CompanyAssociatePartner";
      } else if (this.userData == "employee") {
        this.selectedteam = {
          name: this.userName,
          id: this.userId,
        };
        this.userInfo(this.selectedteam);
      } else if (this.userData == "franchise") {
        this.selectedteam = {
          name: this.userName,
          id: this.userId,
        };
        this.userInfo(this.selectedteam);
      }
      // this.getLedger()
      // this.getCustomer();
    },
    async downlineCP() {
      this.teamOption = [];
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getUserByParentId/${this.loginData.id}`,
      };
      await axios(requestOptions)
        .then((response) => {
          this.teamOption = [this.loginData];
          response.data.data.map((item) => {
            this.teamOption.push(item);
            if (item.children.length > 0) {
              this.handleChild(item.children);
            }
          });
        })
        .catch((error) => console.log(error, "error"));
    },
    handleChild(childs) {
      childs.map((item) => {
        this.teamOption.push(item);
        if (item.children.length > 0) {
          this.handleChild(item.children);
        }
      });
    },
    getEmp(id) {
      // this.selecttype = 'CompanyAssociatePartner'
      if (this.selecttype == "CompanyAssociatePartner") {
        this.getCompanyAssociatePartner(id);
      } else if (this.selecttype == "Franchise") {
        this.getFranchise(id);
      } else if (this.selecttype == "Employee") {
        this.getTeam(id);
      } else {
        this.selectedteam = {
          id: this.userId,
        };
      }
    },
    async getTeam(id) {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getEmployee`,
      };
      await axios(requestOptions)
        .then((response) => {
          this.teamOption = response.data.data;
          if (id !== undefined) {

            this.teamOption.map((item) => {
              if (item.id == id) {
                this.selectedteam = item;
              }
            });
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    async getCompanyAssociatePartner(id) {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getCompanyassociatepartner`,
      };
      await axios(requestOptions)
        .then((response) => {
          this.teamOption = response.data.data;
          if (id !== undefined) {
            this.teamOption.map((item) => {
              if (item.id == id) {
                this.selectedteam = item;
              }
            });
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    async getFranchise(id) {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getFranchise`,
      };
      await axios(requestOptions)
        .then((response) => {
          this.teamOption = response.data.data;
          if (id !== undefined) {
            this.teamOption.map((item) => {
              if (item.id == id) {
                selectedteam = item;
              }
            });
          }
        })
        .catch((error) => console.log(error, "error"));
    },

    addRow() {
      let total = parseFloat(this.firstpayment);
      this.installments.map((item) => {
        total += parseFloat(item.installment_amount);
      });
      if (total < parseFloat(this.totalpayment)) {
        let amount = 0;
        this.installments.map((item) => {
          amount += item.installment_amount;
        });
        this.installments.push({
          installment_date: moment(new Date()).format("DD/MM/yyyy"),
          installment_amount: parseFloat(this.remainingpayment) - amount,
          remarks: "",
          type: "Part Payment",
        });
      } else {
        // Compare with tolerance for floating point precision
        const totalPayment = parseFloat(this.totalpayment) || 0;
        const difference = Math.abs(total - totalPayment);
        if (difference > 0.01) {
          this.$swal({
            title: "Warning",
            timer: 5000,
            text: "Installmant amount should be equal to total payment",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        } else {
          this.$swal({
            title: "Warning",
            timer: 5000,
            text: "Installmant amount is equal to total payment",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        }
      }
    },
    deleteRow(index) {
      this.installments.splice(index, 1);
    },
  },
};
</script>
